module.exports = __webpack_public_path__ + "static/media/index.84380df8.png";